import { render, staticRenderFns } from "./VSymbolIcon.vue?vue&type=template&id=07323c4e&scoped=true&"
import script from "./VSymbolIcon.vue?vue&type=script&lang=js&"
export * from "./VSymbolIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07323c4e",
  null
  
)

export default component.exports